import React, { useState } from "react";
import "./ECommerceService.scss";
import QuoteModal from "../../../../Components/QuoteModal";
import LetDiscuss from "../../../../Components/LetDiscuss";
import TechnologyStackindex from "../../../../Components/TechnologyStack";
import eCommercePlatformDevelopment from "../../../../Assets/Red_Theme/services/details/eCommercePlatformDevelopment.png";
import productpattern from "../../../../Assets/Red_Theme/services/details/product-pattern.png";
import b2beCommercePlateform from "../../../../Assets/Red_Theme/services/details/b2beCommercePlatforms.png";
import c2ceCommercePlatforms from "../../../../Assets/Red_Theme/services/details/c2ceCommercePlatforms.png";
import b2beCommercePlatforms1 from "../../../../Assets/Red_Theme/services/details/b2beCommercePlatforms1.png";
import PWAeCommerce from "../../../../Assets/Red_Theme/services/details/PWAeCommerce.png";
import logosShopify from "../../../../Assets/Red_Theme/services/details/logos_shopify.svg";
import teenyiconsWordpressSolid from "../../../../Assets/Red_Theme/services/details/teenyicons_wordpress-solid.svg";
import ageExperience from "../../../../Assets/Red_Theme/services/details/ageExperience.png";
import checkIcon from "../../../../Assets/Red_Theme/services/details/checkIcon.png";

function ECommerceService() {
  const [isOpen, setOpen] = useState(false);
  const [subject, setSubject] = useState(null);

  const OpenModal = (data) => {
    setSubject(data);
    setOpen(true);
  };

  const ecommerceDevelopmentServices = [
    {
      title: "eCommerce Consulting",
      desc: "Our eCommerce software consultants provide expert guidance on business operations, technology integrations, and efficiency enhancements. Our strategic consultations help elevate customer experiences and boost brand satisfaction.",
    },
    {
      title: "eCommerce Website Development Services",
      desc: "We create powerful and scalable eCommerce websites customized to your business needs, delivering seamless user experiences and peak performance. From intuitive storefronts to smooth checkout processes, our solutions are designed to maximize conversions.",
    },
    {
      title: "eCommerce App Development Services",
      desc: "We develop feature-packed, high-performance mobile apps that elevate the shopping experience. Specializing in iOS and Android eCommerce app development, we create responsive, user-friendly, and secure solutions tailored to your business needs.",
    },
    {
      title: "eCommerce Migrations",
      desc: "Seamlessly migrate your store to a new platform without data loss or downtime. Our experts manage the entire process with precision, ensuring a smooth transition, enhanced scalability, and improved performance.",
    },
    {
      title: "eCommerce Integrations",
      desc: "Integrate your eCommerce store with third-party tools like CRMs, ERPs, payment gateways, and analytics platforms. We ensure seamless connections to enhance functionality, streamline operations, and improve overall efficiency.",
    },
    {
      title: "eCommerce Audit",
      desc: "Our in-depth eCommerce audits uncover performance issues, security risks, and SEO weaknesses. We provide actionable recommendations to optimize your website, enhance user experience, and drive sales growth.",
    },
    {
      title: "eCommerce Support and Maintenance",
      desc: "Our dedicated support and maintenance services ensure your eCommerce store runs seamlessly. We handle technical issues, security updates, and performance enhancements to keep your store optimized.",
    },
    {
      title: "eCommerce Theme Development",
      desc: "Get a tailor-made eCommerce theme that reflects your brand identity and meets customer expectations. Our designs are fully responsive, visually engaging, and optimized for seamless user experience and higher conversions.",
    },
    {
      title: "eCommerce UI/UX Design Services",
      desc: "Our expert UI/UX design services elevate your online store’s aesthetics and functionality. We create intuitive interfaces that enhance user experience, ensuring a seamless shopping journey that drives engagement and customer satisfaction.",
    },
    {
      title: "eCommerce Store Optimization",
      desc: "Is your eCommerce store slow or facing performance issues? Our optimization services enhance site speed, boost search rankings, and improve overall efficiency. We fine-tune every detail to deliver a fast, seamless, and high-converting shopping experience.",
    },
  ];

  const TechnologyStackData = {
    title: (
      <h2>
        Our Command Over <span>Technology</span> Stack
      </h2>
    ),
    desc: "We use top-of-the-line tools, cutting-edge technologies, and modern approaches to expand and grow your business. Our technical stack for delivering exceptional software development projects includes the following trusted components.",
  };

  const eCommerceSolutionsweDevelop = [
    {
      img: b2beCommercePlateform,
      title: "B2B eCommerce Platforms",
      desc: "Our team develops enterprise-grade B2B eCommerce platforms to handle complex workflows, bulk transactions, and tiered pricing. We implement advanced product catalogs, custom pricing rules, and multi-user account management.",
    },
    {
      img: c2ceCommercePlatforms,
      title: "C2C eCommerce Platforms",
      desc: "We create C2C eCommerce platforms that connect buyers and sellers directly. With secure payments, verified user authentication, and seamless communication, our solutions ensure a trustworthy and efficient marketplace experience.",
    },
    {
      img: b2beCommercePlatforms1,
      title: "B2C eCommerce Platforms",
      desc: "We design advanced B2C eCommerce platforms that provide a seamless shopping experience. With intuitive product displays, smooth checkouts, built-in analytics, and personalized recommendations, our solutions drive sales and enhance customer loyalty.",
    },
    {
      img: PWAeCommerce,
      title: "PWA eCommerce",
      desc: "Our PWAs combine the power of websites and mobile apps, offering lightning-fast load times, offline access, and smooth usability. Designed for any device, they enhance user engagement, drive conversions, and boost retention, ensuring a top-tier eCommerce experience.",
    },
  ];
  const ageExperienceList = [
    "Virtual Try-on",
    "3D Modeling",
    "Virtual Try-outs",
    "Voice-enables shopping",
    "Interactive user manuals",
    "IoT-backed eCommerce operations",
    "Decentralized marketplaces",
  ];
  return (
    <>
      <section className="eCommercePlatformDevelopment">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="eCommercePlatformDevelopmentTitle">
                <h1>
                  eCommerce <span>Platform</span> Development
                </h1>
                <p>
                  With over a decade of expertise, we specialize in custom
                  eCommerce development, delivering high-performance websites
                  and apps. From optimizing site speed and accessibility to
                  enhancing conversions, integrating third-party tools, and
                  ensuring top-tier security, we build robust solutions tailored
                  to your needs. Let’s create an exceptional shopping experience
                  together.
                </p>
                <button
                  className="theme_btn"
                  onClick={() => OpenModal("eCommerce Platform Development")}
                >
                  <span>Get Started</span>
                </button>
              </div>
            </div>
            <div className="col-lg-6 rightSide">
              <img
                src={eCommercePlatformDevelopment}
                alt="eCommercePlatformDevelopmentBaner"
                title="eCommercePlatformDevelopmentBaner"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
        <img
          src={productpattern}
          className="img-fluid pattern"
          alt="product-pattern"
        />
      </section>
      <section className="developmentServices">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="eCommercePlatformDevelopmentTitle">
                <h2>
                  Our eCommerce Development <span>Services</span>
                </h2>
                <p>
                  Want to take your online business to the next level and boost
                  customer engagement? Our eCommerce development services
                  deliver high-performance, customized solutions to create a
                  seamless shopping experience tailored to your needs.
                </p>
                <button
                  className="theme_btn"
                  onClick={() => OpenModal("eCommerce Platform Development")}
                >
                  <span>Share Requirements with Us</span>
                </button>
              </div>
            </div>
            <div className="col-lg-6 rightSide">
              {ecommerceDevelopmentServices.map((item, i) => (
                <div className="box" key={i}>
                  <h3>{item.title}</h3>
                  <p>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <TechnologyStackindex TechnologyStackData={TechnologyStackData} />
      <section className="eCommerceSolutionsweDevelop">
        <div className="container">
          <div className="eCommercePlatformDevelopmentTitle">
            <h2>
              eCommerce <span>Solutions</span> we Develop
            </h2>
            <p>
              Our enterprise-oriented, feature-packed solutions are designed to
              address the complex needs of modern businesses. They integrate
              advanced technologies with user-focused design and empower
              eCommerce businesses to optimize workflows, enhance productivity,
              and achieve sustainable growth.
            </p>
          </div>
          <div className="row">
            {eCommerceSolutionsweDevelop.map((item, i) => (
              <div className="col-md-6" key={i}>
                <div className="box">
                  <img src={item.img} className="img-fluid" alt={item.title} />
                  <div className="contain">
                    <h2>{item.title}</h2>
                    <p>{item.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="technologicalExpertise">
        <div className="container">
          <div className="eCommercePlatformDevelopmentTitle">
            <h2>
              Technological <span>Expertise:</span> Our eCommerce Developers
              Possess
            </h2>
            <p>
              At vidhan infotech Our eCommerce developers harness the latest
              technologies, strong frameworks, and innovative strategies to
              build scalable, high-performing platforms.
            </p>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="box">
                <img src={logosShopify} alt="" />
                <h2>Shopify Development Services</h2>
                <p>
                  As certified Shopify experts, we build scalable eCommerce
                  solutions, leveraging Shopify’s ecosystem for high-converting
                  stores, seamless setups, and custom app development. Our focus
                  is on crafting user-friendly shopping experiences that
                  captivate and retain customers. Let’s connect to maximize
                  Shopify’s potential and grow your online business.
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="box">
                <img src={teenyiconsWordpressSolid} alt="" />
                <h2>Wordpress Development Services</h2>
                <p>
                  As WordPress eCommerce experts, we build dynamic, scalable
                  online stores using the power of WooCommerce and WordPress’s
                  ecosystem. From seamless store setup to custom plugin
                  development, we deliver conversion-focused solutions. Our
                  specialty is crafting intuitive, user-friendly shopping
                  experiences that engage and retain customers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ageExperience">
        <div className="container">
          <div className="eCommercePlatformDevelopmentTitle">
            <h2>
              Deliver New Age <span>Experience</span> to Your eCommerce
              Website/App Customers
            </h2>
            <p>
              As technology advances, so do customer expectations, creating new
              opportunities to enhance their shopping experience. Here are some
              cutting-edge solutions you can implement to stay ahead and delight
              your customers.
            </p>
          </div>
          <div className="row">
            <div className="col-md-6">
              <img
                src={ageExperience}
                className="leftbanner img-fluid h-100"
                alt=""
              />
            </div>
            <div className="col-md-6">
              <div className="box">
                <ul>
                  {ageExperienceList.map((item, i) => (
                    <li key={i}>
                      <img src={checkIcon} className="img-fluid" alt={item} />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
      <LetDiscuss />
      {isOpen && (
        <QuoteModal
          open={isOpen}
          setOpen={setOpen}
          CloseModal={() => setOpen(false)}
          subject={subject}
        />
      )}
    </>
  );
}
export default React.memo(ECommerceService);
